import { render, staticRenderFns } from "./PointNetridecashTechcoinComplete.vue?vue&type=template&id=33c0d87c"
import script from "./PointNetridecashTechcoinComplete.vue?vue&type=script&lang=js"
export * from "./PointNetridecashTechcoinComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports